<div class="layout-container" [ngClass]="containerClass">

  <app-topbar></app-topbar>
  <!-- <app-rightmenu></app-rightmenu> -->
  <app-sidebar></app-sidebar>

  <div class="layout-content-wrapper">
    <!-- <app-breadcrumb></app-breadcrumb> -->

    <!-- <div class="layout-content"> -->
    <router-outlet></router-outlet>
  <!-- </div> -->

  <!-- <app-footer></app-footer> -->
</div>
<!--    <app-config></app-config>-->

@if (layoutService.state.staticMenuMobileActive) {
  <div class="layout-mask"></div>
}
</div>
